'use client'

import {useEffect, useRef} from 'react'
import {useAuth} from '@fitro/customer-host/auth'
import {usePathname} from 'next/navigation'
import {resolvePartnerSlug} from '../../lib/partner-slug'
import {isPublicTenantEntryPath} from '../../lib/tenant-seo-policy'
import {linkCustomerToPartner} from '../../services/profile.service'
import {apiBaseUrl} from '@fitro/customer-host/api'

export const PartnerAutoLinker: React.FC = () => {
    const {isLoaded, isSignedIn, userId} = useAuth()
    const pathname = usePathname()
    const lastAttemptRef = useRef<string | null>(null)
    const isPublicTenantPage = Boolean(pathname && isPublicTenantEntryPath(pathname))

    useEffect(() => {
        if (isPublicTenantPage) {
            lastAttemptRef.current = null
            return
        }
        if (!isLoaded || !isSignedIn) {
            lastAttemptRef.current = null
            return
        }
        if (!apiBaseUrl) return

        const slug = resolvePartnerSlug()
        if (!slug) return

        const attemptKey = `${userId ?? 'anonymous'}:${slug}`
        if (lastAttemptRef.current === attemptKey) return
        lastAttemptRef.current = attemptKey

        const run = async () => {
            try {
                await linkCustomerToPartner()
            } catch {
                /* best-effort; profile flows will retry if needed */
            }
        }

        void run()
    }, [isLoaded, isPublicTenantPage, isSignedIn, userId])

    return null
}
